module.exports = __webpack_public_path__ + "static/media/ic222 amg menu.e1f8c51e.jpg";